import styled from 'styled-components';

export const DatePickerContainer = styled.div`
  display: flex;
  position: relative;
  .Polaris-Box--listReset {
    width: 125px;
  }
`;